<template>
  <van-list
    v-model:loading="data.loading"
    :finished="data.finished"
    finished-text="没有更多了"
    @load="data.onLoad"
>
    <div class="item" v-for="item,index in data.list" :key="index">
        <div class="left">
          <div class="text">{{ item.text }}</div>
          <div class="time">{{ item.created_at }}</div>
        </div>
        <div class="right" :style="item.io_value>0?'color:#8368FC':''">
          {{ item.io_value }}
        </div>
    </div>
</van-list>
</template>

<script setup>
import { ref, reactive, toRefs, onBeforeMount, onMounted, watchEffect, computed } from 'vue';
import { useCounterStore } from '@/store';
import { useRoute, useRouter } from 'vue-router';
import {balanceLog} from '@/api/recharge'
/**
* 仓库
*/
const store = useCounterStore();
/**
* 路由对象
*/
const route = useRoute();
/**
* 路由实例
*/
const router = useRouter();
//console.log('1-开始创建组件-setup')
/**
* 数据部分
*/
const data = reactive({})
data.loading = false
data.finished = false
data.day = 0
data.detail = 0
data.page = 1
data.userId = JSON.parse(localStorage.getItem('userInfo')).id
data.onLoad = () => {
  data.getBalanceLog()
}
data.list = []
data.getBalanceLog = () =>{
  balanceLog({
    user_id:data.userId,
    page_num:data.page,
    page_size:10
  }).then(res=>{
    data.list.push(...res.data.data)
    if (res.data.data.length<10) {
      data.finished = true
      data.loading = true
    } else {
      data.loading = false
      data.page = data.page +1
    }
  })
}
onBeforeMount(() => {
  //console.log('2.组件挂载页面之前执行----onBeforeMount')
})
onMounted(() => {
  //console.log('3.-组件挂载到页面之后执行-------onMounted')
})
watchEffect(()=>{
})
// 使用toRefs解构
// let { } = { ...toRefs(data) } 
defineExpose({
  ...toRefs(data)
})

</script>
<style lang='scss' scoped>
.header{
  height: 90px;
  display: flex;
  align-items: center;
  color: #ffffff;
  text-align: center;
  border-bottom: 1px solid #F7F5FF40;
  div{
    display: flex;
    justify-content: center;
    flex: 1;
    width: 50%;
  }
}
.van-list{
  height: 90vh;
  overflow: hidden;
  overflow-y:auto ;
}
.item{
  height: 130px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding:0 32px;
  border-bottom: 1px solid #F7F5FF40;
  .text{
    font-size: 30px;
  }
  .time{
    margin-top: 4px;
    font-size: 26px;
  }
}
img{
  width: 44px;
  height: 44px;
}
::v-deep().van-dropdown-menu__title{
  height: 100%;
  .van-ellipsis{
    height: 100%;
    display: flex;
    align-items: center;
  }
}

// ::v-deep().van-dropdown-item__content{
//   border-radius: 0 0 20px 20px;
//   padding-bottom: 120px;
//   .van-cell{
//     padding: 0 60px;
//     height: 80px;
//     line-height: 80px;
//   }
// }

::v-deep().van-dropdown-menu__title:after{
  display: none;
}
</style>
<style>
 :root{
  --van-dropdown-menu-title-font-size:26px !important;
  --van-dropdown-menu-height:80px !important;
  --van-dropdown-menu-title-padding:0 !important;
  --van-dropdown-menu-background:#323647 !important;
  --van-dropdown-menu-title-text-color:#ffffff !important;
  --van-dropdown-menu-title-active-text-color:#ffffff !important;
  --van-dropdown-menu-option-active-color:#ffffff !important;
  --van-cell-background:#323647 !important;
  --van-cell-font-size: 30px !important;
  --van-loading-text-font-size:30px !important;
  --van-list-loading-icon-size:30px !important;
  /*--van-cell-border-color:transparent !important;
  --van-cell-text-color:#ffffff !important;
  --van-popup-background:#323647 !important; */
 }
</style>